import { useState } from "react";
import { DoubleSlider } from "./Sliders";

const FiltersContainer = ({ values, setRequestFilters }) => {
  const [confidenceThreshold, setConfidenceThreshold] = useState(
    values.confidenceThreshold
  );
  const [cost, setCost] = useState(values.cost);
  const [areaOfApplication, setAreaOfApplication] = useState(
    values.areaOfApplication
  );
  const [topologicalEffect, setTopologicalEffect] = useState(
    values.topologicalEffect
  );
  const [implementationTimeframe, setImplementationTimeframe] = useState(
    values.implementationTimeframe
  );

  function invokeDSS() {
    if (
      confidenceThreshold === values.confidenceThreshold &&
      cost === values.cost &&
      areaOfApplication === values.areaOfApplication &&
      topologicalEffect === values.topologicalEffect &&
      implementationTimeframe === values.implementationTimeframe
    )
      return;

    setRequestFilters((prevFilters) => ({
      ...prevFilters,
      confidenceThreshold: confidenceThreshold,
      cost: cost,
      areaOfApplication: areaOfApplication,
      topologicalEffect: topologicalEffect,
      implementationTimeframe: implementationTimeframe,
    }));
  }

  return (
    <section className="dss-filters-section">
      <ThresholdFilter
        title="Confidence Threshold"
        values={[confidenceThreshold, 100]}
        setFilters={setConfidenceThreshold}
        invokeDSS={invokeDSS}
      />
      <Filter
        title="Cost"
        values={cost}
        setFilters={setCost}
        invokeDSS={invokeDSS}
      />
      <Filter
        title="Area of Application"
        values={areaOfApplication}
        setFilters={setAreaOfApplication}
        invokeDSS={invokeDSS}
      />
      <Filter
        title="Topological Effect"
        values={topologicalEffect}
        setFilters={setTopologicalEffect}
        invokeDSS={invokeDSS}
      />
      <Filter
        title="Impl. Timeframe"
        values={implementationTimeframe}
        setFilters={setImplementationTimeframe}
        invokeDSS={invokeDSS}
      />
    </section>
  );
};

const Filter = ({ title, values, setFilters, invokeDSS }) => {
  const [focus, setFocus] = useState(false);

  function handleChange(value) {
    if (!Array.isArray(value)) {
      setFilters(value);
      return;
    }
    if (value[0] === value[1] && values[0] === value[0]) {
      setFilters([value[0], value[0] + 1]);
    } else if (value[0] === value[1] && values[1] === value[1]) {
      setFilters([value[1] - 1, value[1]]);
    } else {
      setFilters(value);
    }
  }
  return (
    <div
      className="dss-filter"
      onMouseEnter={() => setFocus(true)}
      onMouseLeave={() => setFocus(false)}
    >
      <div className="slider-container">
        <div className="slider-container-title">{title}</div>
        <div className="slider-container-values">
          {Array.isArray(values) ? `${values[0]}-${values[1]}` : values}
        </div>
        <DoubleSlider
          valueLabelDisplay={focus ? "on" : "off"}
          size="small"
          value={values}
          onChange={(e) => handleChange(e.target.value)}
          onMouseUp={invokeDSS}
          marks
          step={1}
          min={1}
          max={10}
          disableSwap
        />
      </div>
    </div>
  );
};

const ThresholdFilter = ({ title, values, setFilters, invokeDSS }) => {
  const [focus, setFocus] = useState(false);

  function handleChange(value) {
    if (value[0] === 100) {
      setFilters(99);
    } else {
      setFilters(value[0]);
    }
  }
  return (
    <div
      className="dss-filter"
      onMouseEnter={() => setFocus(true)}
      onMouseLeave={() => setFocus(false)}
    >
      <div className="slider-container">
        <div className="slider-container-title">{title}</div>
        <div className="slider-container-values">
          {values[0]}% - {values[1]}%
        </div>
        <DoubleSlider
          valueLabelDisplay={focus ? "on" : "off"}
          size="small"
          value={values}
          onChange={(e) => handleChange(e.target.value)}
          onMouseUp={invokeDSS}
          marks
          step={10}
          min={0}
          max={100}
          disableSwap
        />
      </div>
    </div>
  );
};

export default FiltersContainer;
